import {useSelector} from 'react-redux';

import isEqual from 'lodash/isEqual';

type TAnySelector = (state: any) => any;

const useExactSelector = <Selector extends TAnySelector = TAnySelector>(
  selector: Selector,
): ReturnType<Selector> => useSelector(selector, isEqual);

export default useExactSelector;
